import * as React from 'react';

import { L10n } from '~src/ts/L10n/L10n';

import { Messages } from '../../../codegen/Localize';
import { ConnectionTypeEntity } from '../../../datasource/components/tooltips/DatasourceEntity';
import { IDataSourceInfo, IPublishedDatasourceInfoProperties} from '../../../datasource/models/IDataSourceInfo';
import { ConnectionDisplay } from '../ListView/DataConnectionComponents';
import { DatasourceTooltip} from './Elements/Tooltip';
import { StatusTooltipProps} from './TooltipHelper';

let metadata: ConnectionDisplay.Metadata;
let publishedDetails: IPublishedDatasourceInfoProperties;
let publishedDSMessage: string;
let isPublished: boolean;

export function ConnectionToolTip(props: StatusTooltipProps): JSX.Element {
  const datasource = props.content as IDataSourceInfo;
  publishedDetails = datasource.publishedDatasourceDetails;
  metadata = ConnectionDisplay.getDisplayMetadata(props.content,props.urls);
  isPublished = publishedDetails? true:false;
  let connectionType = datasource.connectionDetails.type === 'file' ? datasource.connectionTypeDisplayName : 'Data source';
  if(isPublished){
    if(datasource.connectionDetails.type === 'file'){
        publishedDSMessage = Messages.fileBased();}
    else{
        toolTipContent(props.content);}
    }
  else{
        publishedDSMessage = undefined;
        if(datasource.connectionDetails.type === 'file'){
            connectionType = Messages.embeddedFileConnection({CONNECTION_TYPE: datasource.connectionTypeDisplayName});
          }
        else{
            connectionType = Messages.embeddedDatabaseConnection({CONNECTION_TYPE: datasource.connectionTypeDisplayName});}
      }

  return (
    <DatasourceTooltip>
      <ConnectionTypeEntity name = {metadata.connectionName} fileType={connectionType} connectionDetails={publishedDSMessage}/>
    </DatasourceTooltip>
  );
}

function toolTipContent(datasource: IDataSourceInfo) {
    if(publishedDetails.hasExtracts) {
        publishedDSMessage = Messages.lastRefreshed()+' '+L10n.localizedDateTime(publishedDetails.lastRefreshedAt);
      return;
    }
    publishedDSMessage = undefined;
  }




